import { getTotalExperience } from "../services/utilService";
import { experienceData } from "./experience.js";
import { education as educationDetails } from "./experience.js";
import { resumeSkills as skills } from "./skills.js";
import { profile, resumeFileName } from "./profile.js";

export { experienceData, skills };

export const professionalSummary = (
  <>
    Senior Software Engineer with {getTotalExperience(0.5)} shipping full-stack
    products and AI systems across fintech, aviation, logistics, and healthcare.
    Currently leading AI agent delivery at Lua AI, with production WhatsApp
    agents live in five countries at 95%+ on daily QA audits. Strengths:
    test-driven development and release quality, platform engineering on
    high-traffic systems, and leading cross-functional teams and client
    engagements end to end.
  </>
);

export const education = {
  institute: educationDetails.instituteFull,
  degree: educationDetails.degreeFull,
  batch: educationDetails.date,
};

export const resumeDownloadOptions = {
  name: profile.name,
  fileName: resumeFileName(),
};

export const additionalInfo = [
  {
    title: "Languages",
    content: "English (Professional)",
  },
  {
    title: "Hobbies",
    content: "Table Tennis, Video Games, Hiking",
  },
];
